export const recyclerData = [
    {customerId: 1, name: "Armada-Hub One"},
    {customerId: 2, name: "Food Authority"},
    {customerId: 3, name: "Chick-fil-A"},
    {customerId: 4, name: "Martin Brower"},
    {customerId: 5, name: "McLane"},
    {customerId: 6, name: "QCD"}
];
